import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import Transactions from "./pages/Transactions";
import Ebooks from "./pages/Ebooks";
import Profile from "./pages/Profile";
import Videos from "./pages/Videos";
import SignupPage from "./pages/SignupPage";
import LoginPage from "./pages/LoginPage";
import AdminUploadEbook from "./pages/AdminUploadEbooks";
import AdminUploadVideo from "./pages/AdminUploadVideo";
import AdminUploadCourse from "./pages/AdminUploadCourses";
import Attendance from "./pages/AdminAttendance";
import AdminCourseSchedule from "./pages/AdminCourseSchedule";
import AdminContentUploadTabs from "./pages/AdminContentUploadTabs";
import AdminSchedulePage from "./pages/AdminSchedulePage";
import AdminCourseTransactionPage from "./pages/StudentRegistration";
import CoachAssignmentPanel from "./pages/CoachAssignment";
import SessionScheduleTracker from "./pages/SessionScheduleTracker";
import AdminRevenueReport from "./pages/AdminRevenueReport";
import MonthlyReportSummary from "./pages/MonthlyReportSummary";
import Subscriptions from "./pages/Subscriptions";
import AdminSubscriptionPost from "./components/AdminSubscriptionPost";
import AdminSubscriptionManagement from "./pages/AdminSubscriptionManagement";

const App = () => {
  
  return (
    <Router>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/ebooks" element={<Ebooks />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/uploadEbooks" element={<AdminUploadEbook />} />
        <Route path="/uploadVideos" element={<AdminUploadVideo />} />
        <Route path="/uploadCourses" element={<AdminUploadCourse />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/admin/schedule/:courseId" element={<AdminCourseSchedule />} />
        <Route path="/schedule" element={<AdminContentUploadTabs />} />
        <Route path="/admin/schedule" element={<AdminSchedulePage />} />
        <Route path="/admin/registration" element={<AdminCourseTransactionPage />} />
        <Route path="/admin/coach" element={<CoachAssignmentPanel />} />
        <Route path="/admin/session" element={<SessionScheduleTracker />} />
        <Route path="/admin/revenue" element={<AdminRevenueReport />} />
        <Route path="/admin/monthly-report" element={<MonthlyReportSummary />} />
        <Route path="/en/login" element={<LoginPage lang="en" />} />
        <Route path="/ar/login" element={<LoginPage lang="ar" />} />
        <Route path="/en/signup" element={<SignupPage lang="en" />} />
        <Route path="/ar/signup" element={<SignupPage lang="ar" />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/admin/subscriptions/post" element={<AdminSubscriptionPost />} />
        <Route path="/admin/subscriptions" element={<AdminSubscriptionManagement />} />
      </Routes>
    </Router>
  );
};

export default App;
